import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Twitter, Facebook, Mail, MapPin, Phone } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-24 bg-black text-white relative overflow-hidden" data-testid="site-footer">
      {/* Decorative grain */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(#fff 1px, transparent 1px)",
          backgroundSize: "4px 4px",
        }}
      />

      {/* Main grid */}
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-2 md:grid-cols-12 gap-12">
        {/* Brand col */}
        <div className="col-span-2 md:col-span-4">
          <Link to="/" className="inline-flex items-center group">
            <Logo className="h-20 w-20" />
          </Link>
          <p className="mt-6 text-white/60 leading-relaxed max-w-sm">
            Premium Adire — handcrafted in Nigeria. Tradition reimagined for the modern wardrobe.
          </p>

          <div className="mt-8 flex gap-3" data-testid="footer-social">
            {[
              { Icon: Instagram, label: "Instagram", href: "#" },
              { Icon: Twitter, label: "Twitter", href: "#" },
              { Icon: Facebook, label: "Facebook", href: "#" },
            ].map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-[#FED700] hover:border-[#FED700] hover:text-black transition-all duration-300"
                data-testid={`footer-social-${label.toLowerCase()}`}
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {/* Shop */}
        <div className="md:col-span-2">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#FED700] font-semibold mb-6">Shop</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/shop?category=Accessories" className="hover:text-white transition-colors inline-flex items-center gap-1 group">Accessories <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" /></Link></li>
            <li><Link to="/shop?category=Clothing" className="hover:text-white transition-colors inline-flex items-center gap-1 group">Clothing <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" /></Link></li>
            <li><Link to="/shop?category=Bags" className="hover:text-white transition-colors inline-flex items-center gap-1 group">Bags <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" /></Link></li>
            <li><Link to="/shop" className="hover:text-white transition-colors inline-flex items-center gap-1 group">All Products <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" /></Link></li>
          </ul>
        </div>

        {/* Account */}
        <div className="md:col-span-2">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#FED700] font-semibold mb-6">Account</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/login" className="hover:text-white transition-colors">Sign In</Link></li>
            <li><Link to="/register" className="hover:text-white transition-colors">Create Account</Link></li>
            <li><Link to="/wishlist" className="hover:text-white transition-colors">Wishlist</Link></li>
            <li><Link to="/profile" className="hover:text-white transition-colors">My Orders</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="col-span-2 md:col-span-4">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#FED700] font-semibold mb-6">Atelier</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#FED700] mt-0.5 flex-shrink-0" />
              <span>Lagos, Nigeria<br />store.ajoyo.org</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#FED700] flex-shrink-0" />
              <a href="mailto:hello@ajoyo.org" className="hover:text-white transition-colors">hello@ajoyo.org</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#FED700] flex-shrink-0" />
              <span>+234 800 000 0000</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] tracking-[0.2em] uppercase text-white/50">
          <p>© {new Date().getFullYear()} Ajoyo Store · All rights reserved</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Shipping</a>
            <span className="hidden md:inline opacity-60">Secured by</span>
            <span className="font-bold text-[#FED700]">Paystack</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
